/**
 * Created by Udara Prabath
 * Date: 10/30/2020
 * Using: IntelliJ IDEA
 */

import React from "react";
import './Lesson.scss'
import {Button, Col, Row} from "reactstrap";
import {lang, language} from "../../const/language";
import Slider from "react-slick";
import Placeholder from "../../assets/img/common/placeholder.png";
import * as actionCreator from "../../store/domain/classes/action";
import * as actionSpinnerCreator from "../../store/domain/spinner/action";
import * as actionModalCreator from "../../store/domain/modal/action";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import * as constants from "../../const/constants";
import {BOUGHT_TEXT, BUY_TEXT, PENDING_TEXT,RE_BUY_TEXT} from "../../const/constants";
import {setPaymentModal_} from "../../store/domain/modal/action";
import swal from "sweetalert";
import {getSliderSetting} from "../../utils/commonFunc";


class LessonItem extends React.Component {

    purchaseHandler = (lessonId) => {
        this.props.setPaymentModal(true,{lessonId:lessonId})
    };

    viewLesson = (lesson) => {
        if(this.props.userType === 1){
            // if (lesson.buttonStatus === BUY_TEXT){
            //     this.purchaseHandler(lesson.id)
            // } else if (lesson.buttonStatus === BOUGHT_TEXT){
                this.props.history.push({
                    pathname: `${constants.BASE_ROUTE}${constants.HOME_VIEW_SELECTED_LESSON_ROUTE}`,
                    state: {
                        ...lesson,
                        btnStatus: lesson.buttonStatus,
                        firstWeek: false,
                        classId: 0
                    }
                })
            // }
        }else {
            swal({
                title: constants.GUEST_STUDENT_FOR_CLASS_LESSON_PURCHASE,
                icon: null,
                closeOnClickOutside: false,
                buttons: {
                    cancel: language[lang].NotNowText,
                    dangerMode: {text: language[lang].OkayText, value: "action", className: "okay-btn"}
                },
            }).then((value) => {
                switch (value) {
                    case "action":
                        window.location = `${constants.BASE_ROUTE}${constants.AUTH_LOGIN_ROUTE}`;
                        break;
                    default:
                        break;
                }
            });
        }
    };

    render() {
        const {lessons} = this.props;

        let settings = getSliderSetting(lessons);

        return (
            <div>
                <div className="lesson-item ">
                    <Slider {...settings}>
                        {
                            lessons.map((item,index)=>{
                                return(
                                    <div key={index}>
                                        <div className={`slideshow-wrapper shadow border-0 card`}>
                                            <div className={"display-inline slideshow-user-wrapper"}>
                                                <img
                                                    src={item.image ? item.image : Placeholder}
                                                    alt={"."}
                                                    className={"blur-img"}/>
                                                <img
                                                    src={item.image ? item.image : Placeholder}
                                                    alt={"."}
                                                    className={"slideshow-pro-image"}/>
                                                <div className={"slideshow-middle"} >
                                                    <div className={"cursor minHeight"}>
                                                        <div onClick={()=> this.viewLesson(item)}>
                                                            <h4 className={"topic"}>{item.name}</h4>

                                                            <Row className={"card-row"}>
                                                                <Col xs="12"><p className={"qualification"}>
                                                                    LKR {parseFloat(item.fee ? item.fee : 0).toFixed(2)} - &nbsp;
                                                                     {language[lang].validAfterPayment} {item.validityDays}</p></Col>
                                                            </Row>
                                                            <Row className={"card-row"}>
                                                                <Col xs="12"><p className={"description"}>{item.description}</p></Col>
                                                            </Row>
                                                        </div>

                                                        <div className={"btn-ctrl"}>
                                                            {
                                                                item.buttonStatus === BUY_TEXT ?
                                                                    <Button className={"log-btn com-btn bold-text "}
                                                                            onClick={() => this.purchaseHandler(item.id)}
                                                                    >
                                                                        {language[lang].PurchaseTheLesson}
                                                                    </Button>
                                                                    : item.buttonStatus === PENDING_TEXT ?
                                                                    <Button className={"reg-btn com-btn bold-text "}>
                                                                        {language[lang].PaymentPending}
                                                                    </Button>
                                                                    :
                                                                    <Button className={"reg-btn com-btn bold-text "}
                                                                        onClick={()=>this.viewLesson(item)}>
                                                                        {language[lang].PaidForTheLesson}
                                                                    </Button>

                                                            }
                                                            {
                                                                item.buttonStatus === RE_BUY_TEXT &&
                                                                <Button className={"log-btn com-btn bold-text mt-3"}
                                                                        onClick={()=>this.purchaseHandler(item.id)}>
                                                                    {language[lang].RePaidForTheLesson}
                                                                </Button>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </Slider>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    userType: state.auth.userType,
});

const mapDispatchToProps = (dispatch) => ({
    setPaymentModal: (data,value) => dispatch(actionModalCreator.setPaymentModal(data,value))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LessonItem));
